import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { installSameOriginApiPatch } from "@/lib/sameOriginApi";

// Install at startup. Rewrites cross-origin /api/* fetches to same-origin
// IFF the current origin actually serves /api/*. This makes the app robust
// to a stale or incorrect REACT_APP_BACKEND_URL bake (e.g., production build
// shipped with a preview URL).
installSameOriginApiPatch();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
